<template>
  <v-row justify="center">
    <v-dialog v-model="show" fullscreen hide-overlay transition="dialog-bottom-transition">
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon dark @click="$emit('close')">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>{{title}}</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-card-text>
          <client-editor :clientId="clientId" :isModal="true" @saved="onClientSaved"></client-editor>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import ClientEditor from "../clients/ClientEditor";
export default {
  name: "modal-client-edit",
  props: {
    show: {
      type: Boolean,
      default: () => false
    },
    value: {
      type: Object,
      default: () => null
    }
  },
  components: {
    ClientEditor
  },
  computed: {
    title() {
      return this.value
        ? `Editing ${this.value.name} ${this.value.surname}`
        : "Editing Client";
    },
    clientId() {
      if (this.value && this.value.client && this.value.client.id) {
        return this.value.client.id;
      } else if (this.value && this.value.id) {
        return this.value.id;
      } else {
        return "";
      }
    }
  },
  methods: {
    onClientSaved(payload) {
      this.$emit("update-client", { ...payload });
    }
  }
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/gt/shared/ModalClientEdit.vue